import { render, staticRenderFns } from "./icon-reception.vue?vue&type=template&id=e7b19e4c&scoped=true&"
import script from "./icon-reception.vue?vue&type=script&lang=js&"
export * from "./icon-reception.vue?vue&type=script&lang=js&"
import style0 from "./icon-reception.vue?vue&type=style&index=0&id=e7b19e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b19e4c",
  null
  
)

export default component.exports